import { render, staticRenderFns } from "./SectionExCourceList.vue?vue&type=template&id=70eb5dee&"
import script from "./SectionExCourceList.vue?vue&type=script&lang=js&"
export * from "./SectionExCourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports